import { Draft, PayloadAction } from '@reduxjs/toolkit';

export const createUpdateReducer = <TState>() => {
    return <TKey extends keyof Draft<TState>>(
        state: Draft<TState>,
        action: PayloadAction<{ key: TKey; value: Draft<TState>[TKey] }>
    ) => {
        state[action.payload.key] = action.payload.value;
    };
};

export const createPublicUpdateReducer = <TState extends { public: any }, TPublic = Draft<TState>['public']>() => {
    return <TKey extends keyof TPublic>(
        state: Draft<TState>,
        action: PayloadAction<{ key: TKey; value: TPublic[TKey] }>
    ) => {
        state.public[action.payload.key] = action.payload.value;
    };
};